module.exports = __webpack_public_path__ + "static/img/green_car.a447f9fc.png";